import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import RightMenuListMobile from './components/AppHeader/RightMenuListMobile';
import AppHeader from './components/AppHeader';
import WithDeviceDetailsHOC from './components/HOCs/WithDeviceDetailsHOC';

import UseWindowSize from './hooks/UseWindowSize';

import Resturants from './pages/Resturants';
import Help from './pages/Help';
import Cart from './pages/Cart';
import Search from './pages/Search';
import Offers from './pages/Offers';
import Account from './pages/Account';

const routes = [
  { path: '/', component: WithDeviceDetailsHOC(Resturants) },
  { path: '/home', component: WithDeviceDetailsHOC(Resturants) },
  { path: '/resturants', component: WithDeviceDetailsHOC(Resturants) },
  { path: '/help', component: WithDeviceDetailsHOC(Help) },
  { path: '/offers', component: WithDeviceDetailsHOC(Offers) },
  { path: '/cart', component: WithDeviceDetailsHOC(Cart) },
  { path: '/search', component: WithDeviceDetailsHOC(Search) },
  { path: '/search', component: WithDeviceDetailsHOC(Search) },
  { path: '/account', component: WithDeviceDetailsHOC(Account) }
];

export default function App() {
  const size = UseWindowSize() || {};
  const { width } = size || {};

  return (
    <Router>
      <div>
        <AppHeader visible={true} />
        <Switch>
          {routes.map((route) => (
            <Route
              key={route.path}
              exact
              path={route.path}
              component={route.component}
            />
          ))}
        </Switch>
        {
          // @ts-ignore
          width < 900 && <RightMenuListMobile />
        }
      </div>
    </Router>
  );
}
